<template>
  <div class="content">
    <div class="container-fluid">
        <!-- <a :href="apiUrl+'report-all'" target="_BLANK" class="btn btn-sm btn-primary mb-4"><i class="fa fa-download fa-sm"></i> Generate Report</a> -->
      <div class="row" v-if="role != 'Visitor'">
        <div class="col-xl-3 col-md-6 stat-accent stat-accent-blue">
          <router-link :to="'/client-master'">
            <stats-card class="shadow">
              <div slot="header" class="icon-warning">
                <i class="nc-icon nc-badge text-muted"></i>
              </div>
              <div slot="content">
                <p class="card-category">Client Master</p>
                <h4 class="card-title">{{ count_task.client }}</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-3 col-md-6 stat-accent stat-accent-green">
          <router-link :to="'/material-master'">
            <stats-card class="shadow">
              <div slot="header" class="icon-warning">
                <i class="nc-icon nc-app text-info"></i>
              </div>
              <div slot="content">
                <p class="card-category">Mother Coil</p>
                <h4 class="card-title">{{ count_task.material }}</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-3 col-md-6 stat-accent stat-accent-amber">
          <router-link :to="'/slit-coil'">
            <stats-card class="shadow">
              <div slot="header" class="icon-warning">
                <i class="nc-icon nc-support-17 text-light"></i>
              </div>
              <div slot="content">
                <p class="card-category">Slit Coil</p>
                <h4 class="card-title">{{ count_task.slit_coil }}</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-3 col-md-6 stat-accent stat-accent-rose">
          <router-link :to="'/job-request'">
            <stats-card class="shadow">
              <div slot="header" class="icon-danger">
                <i class="nc-icon nc-notes text-danger"></i>
              </div>
              <div slot="content">
                <p class="card-category">Job Order</p>
                <h4 class="card-title">{{ count_task.job_request }}</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-3 col-md-6 stat-accent stat-accent-violet">
          <router-link :to="'/delivery'">
            <stats-card class="shadow">
              <div slot="header" class="icon-danger">
                <i class="nc-icon nc-delivery-fast text-warning"></i>
              </div>
              <div slot="content">
                <p class="card-category">Delivery</p>
                <h4 class="card-title">{{ count_task.delivery }}</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <!-- <div class="col-xl-3 col-md-6">
          <router-link :to="'/news'">
            <stats-card class="shadow">
              <div slot="header" class="icon-info">
                <i class="nc-icon nc-paper-2 text-dark"></i>
              </div>
              <div slot="content">
                <p class="card-category">BA</p>
                <h4 class="card-title">{{ count_task.news }}</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div> -->

        <div class="col-xl-3 col-md-6 stat-accent stat-accent-sky">
          <router-link :to="'/invoice'">
            <stats-card class="shadow">
              <div slot="header" class="icon-info">
                <i class="nc-icon nc-single-copy-04 text-primary"></i>
              </div>
              <div slot="content">
                <p class="card-category">Invoice</p>
                <h4 class="card-title">{{ count_task.invoice }}</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-3 col-md-6 stat-accent stat-accent-slate">
          <router-link :to="'/payment'">
            <stats-card class="shadow">
              <div slot="header" class="icon-info">
                <i class="nc-icon nc-credit-card text-success"></i>
              </div>
              <div slot="content">
                <p class="card-category">Payment</p>
                <h4 class="card-title">0</h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>
      </div>

      <div class="row mb-4" v-if="role != 'Visitor'">
        <div class="col-6">
          <div class="chart-box" style="height: 340px;">
            <p class="chart-box-title"><span class="section-dot dot-blue"></span><i class="fa fa-shopping-cart"></i> Tren Tonase Job Order per Bulan - {{ currentYear }}</p>
            <line-chart :chart-data="orderTrendChartData" :options="orderTrendChartOptions" :height="280"></line-chart>
          </div>
        </div>
        <div class="col-6">
          <div class="chart-box" style="height: 340px;">
            <p class="chart-box-title"><span class="section-dot dot-green"></span><i class="fa fa-industry"></i> Tren Tonase Produksi per Bulan - {{ currentYear }}</p>
            <line-trend-chart :chart-data="productionTrendChartData" :options="productionTrendChartOptions" :height="280"></line-trend-chart>
          </div>
        </div>
      </div>

        <div class="table-responsive" v-if="role != 'Visitor'">
          <card class="strpied-tabled-with-hover shadow"
                  body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="row">
                  <div class="col-3">
                    <!-- <h4 class="card-title">Payment</h4> -->
                  </div>
                  <div class="col-6 text-center">
                    <h5 class="card-title font-weight-bold">STEEL CENTER</h5><br>
                    <h5 class="card-title font-weight-bold" style="margin-top: -20px;">PROJECT MONITORING - {{currentYear}}</h5><br>
                    <h5 class="card-title font-weight-bold" style="margin-top: -20px; margin-bottom: -30px;">PT. BUANA CENTRA KARYA</h5><br>
                  </div>
                  <div class="col-3 mt-4">
                    <a :href="apiUrl+'print-project-monitoring?job_no='+search.job_no+'&po_no='+search.po_no+'&client_name='+search.client_name+'&prod_class='+search.prod_class+'&date='+search.date+''" target="_BLANK">
                      <button type="submit" class="btn btn-sm btn-success btn-fill float-right ml-2">
                        <i class="fa fa-file-text"></i> Print
                      </button>
                    </a>
                    <button type="submit" class="btn btn-sm btn-secondary btn-fill float-right" @click="filter()"><i class="fa fa-filter"></i> Filter</button>
                  </div>
                </div>
              </template>
              <p class="section-title"><span class="section-dot dot-slate"></span><i class="fa fa-industry"></i> Rincian Project</p>
              <div class="scroll">
                <table class="table" border="1">
                  <thead>
                    <slot name="columns">
                      <tr>
                        <th style="font-size: 12px; text-align: center; background-color: #67728c; color: #fff;">No</th>
                        <th style="font-size: 12px; text-align: center; background-color: #67728c; color: #fff;">Job No</th>
                        <th style="font-size: 12px; text-align: center; background-color: #67728c; color: #fff;">Po No</th>
                        <th style="font-size: 12px; text-align: center; background-color: #67728c; color: #fff;">Client</th>
                        <th style="font-size: 12px; text-align: center; background-color: #67728c; color: #fff;">Date</th>
                        <th style="font-size: 12px; text-align: center; background-color: #67728c; color: #fff;">Prod Class</th>
                        <th style="font-size: 12px; text-align: center; background-color: #dba434; color: #fff;">Weight</th>
                        <th style="font-size: 12px; text-align: center; background-color: #dba434; color: #fff;">Rate</th>
                        <th style="font-size: 12px; text-align: center; background-color: #dba434; color: #fff;">Total</th>
                        <th style="font-size: 12px; text-align: center; background-color: #8f7bc9; color: #fff;">Delivery Out</th>
                        <th style="font-size: 12px; text-align: center; background-color: #8f7bc9; color: #fff;">Delivery Sisa</th>
                        <th style="font-size: 12px; text-align: center; background-color: #8f7bc9; color: #fff;">Delivery Total (Rp)</th>
                        <th style="font-size: 12px; text-align: center; background-color: #5cb583; color: #fff;">Ba Out</th>
                        <th style="font-size: 12px; text-align: center; background-color: #5cb583; color: #fff;">Ba Sisa</th>
                        <th style="font-size: 12px; text-align: center; background-color: #5cb583; color: #fff;">Ba Total</th>
                        <th style="font-size: 12px; text-align: center; background-color: #4fa3d1; color: #fff;">Invoice Out</th>
                        <th style="font-size: 12px; text-align: center; background-color: #4fa3d1; color: #fff;">Invoice Sisa</th>
                        <th style="font-size: 12px; text-align: center; background-color: #4fa3d1; color: #fff;">Invoice Amount</th>
                      </tr>
                    </slot>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td style="font-size: 13px; text-align: center;">{{ i + 1 }}</td>
                      <td style="font-size: 13px;">
                        <router-link :to="/detail-job-request/+row.job_no"><label style="cursor: pointer;" class="badge badge-success">{{row.job_no}}</label></router-link>
                      </td>
                      <td style="font-size: 13px;">{{row.po_no}}</td>
                      <td style="font-size: 13px;">{{row.client_name}}</td>
                      <td style="font-size: 13px;">{{ moment(row.created_at).locale('id').format('L') }}</td>
                      <td style="font-size: 13px;">{{row.prod_class}}</td>
                      <td style="font-size: 13px; background-color: #fdf6e8;">{{ convertRp(row.weight) }}</td>
                      <td style="font-size: 13px; background-color: #fdf6e8;">{{row.rate}}</td>
                      <td style="font-size: 13px; background-color: #fdf6e8;">{{ convertRp(row.weight * row.rate) }}</td>
                      <!-- DELIVERY -->
                      <td style="font-size: 13px; background-color: #f4f1fb;">{{ convertRp(row.delivery_qty) }}</td>
                      <td style="font-size: 13px; background-color: #f4f1fb;" v-if="row.delivery_qty">{{ convertRp(row.weight - row.delivery_qty) }}</td>
                      <td v-else style="font-size: 13px; background-color: #f4f1fb;"></td>
                      <td style="font-size: 13px; background-color: #f4f1fb;">{{ convertRp(row.delivery_qty * row.rate) }}</td>
                      <!-- NEWS -->
                      <td style="font-size: 13px; background-color: #eef8f2;">{{ convertRp(row.news_qty) }}</td>
                      <td style="font-size: 13px; background-color: #eef8f2;"  v-if="row.news_qty">{{ convertRp(row.weight - row.news_qty) }}</td>
                      <td v-else style="font-size: 13px; background-color: #eef8f2;"></td>
                      <td style="font-size: 13px; background-color: #eef8f2;">{{ convertRp(row.news_qty * row.rate) }}</td>
                      <!-- INVOICE -->
                      <td style="font-size: 13px; background-color: #eef7fc;">{{ convertRp(row.invoice_qty) }}</td>
                      <td style="font-size: 13px; background-color: #eef7fc;"  v-if="row.invoice_qty">{{ convertRp(row.weight - row.invoice_qty) }}</td>
                      <td v-else style="font-size: 13px; background-color: #eef7fc;"></td>
                      <td style="font-size: 13px; background-color: #eef7fc;">{{ convertRp(row.invoice_qty * row.rate) }}</td>
                    </tr>
                    <tr class="row-highlight" v-if="table.data.length">
                      <td style="font-size: 13px; font-weight: bold;" colspan="6">TOTAL</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumField(table.data, 'weight')) }}</td>
                      <td style="font-size: 13px;"></td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumProduct(table.data, 'weight', 'rate')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumField(table.data, 'delivery_qty')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumField(table.data, 'weight') - sumField(table.data, 'delivery_qty')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumProduct(table.data, 'delivery_qty', 'rate')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumField(table.data, 'news_qty')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumField(table.data, 'weight') - sumField(table.data, 'news_qty')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumProduct(table.data, 'news_qty', 'rate')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumField(table.data, 'invoice_qty')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumField(table.data, 'weight') - sumField(table.data, 'invoice_qty')) }}</td>
                      <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(sumProduct(table.data, 'invoice_qty', 'rate')) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </card>
        </div>

        <!-- MODAL FILTER -->
        <div>
           <modal :show.sync="formFilter.show">
             <template slot="header">
                <h5 class="modal-title" id="exampleModalLabel">{{formFilter.title}}</h5>
             </template>
             <div>
              <base-input type="text"
                    label="Job No"
                    placeholder="Job No"
                    v-model="search.job_no">
              </base-input>
              <base-input type="text"
                    label="Po Number"
                    placeholder="Po Number"
                    v-model="search.po_no">
              </base-input>
              <div class="form-group">
                <label>Client</label><br>
                <autocomplete 
                  ref="autocomplete"
                  :url="apiUrl+'client/find-client'"
                  :customHeaders="{ Authorization: tokenApi }"
                  anchor="client_name"
                  label="client_code"
                  :on-select="getDataFilter"
                  placeholder="Choose Client"
                  :min="3"
                  :process="processJSON"
                  :classes="{ input: 'form-control', list: 'list', item: 'data-list-item' }"
                  >
                </autocomplete>
              </div>
              <div class="form-group">
                <label>Production Classification</label><br>
                <select class="form-select form-control" aria-label="Default select example" v-model="search.prod_class">
                  <option selected>Select Classification</option>
                  <option value="Slitting">Slitting</option>
                  <option value="Tolling">Tolling</option>
                  <option value="Shearing">Shearing</option>
                </select>
              </div>
              <small class="d-block text-uppercase font-weight-bold mb-3">Date range</small>
              <div class="input-daterange datepicker row align-items-center">
                  <div class="col">
                      <base-input addon-left-icon="ni ni-calendar-grid-58">
                          <flat-picker slot-scope="{focus, blur}"
                                       @on-open="focus"
                                       @on-close="blur"
                                       :config="{allowInput: true, mode: 'range',}"
                                       class="form-control datepicker"
                                       v-model="search.date">
                          </flat-picker>
                      </base-input>
                  </div>
              </div>

             </div>
             <template slot="footer">
                 <base-button type="secondary" class="btn btn-sm btn-secondary btn-fill mr-4" @click="formFilter.show = false">Close</base-button>
                 <base-button type="primary" class="btn btn-sm btn-info btn-fill" @click="countTask(), formFilter.show = false">Filter</base-button>
             </template>
           </modal>
        </div>

        <!-- JIKA ROLE NYA VISITOR -->
        <div v-if="role == 'Visitor'">
          <p class="display-2 img-fluid floating align-content-center">Hallo Selamat Datang di Simpro BCK</p>
          <img src="img/theme/Hello.png" class="img-fluid floating">
        </div>

      <!-- <div class="container-fluid" style="width: 900px;">
        <line-chart :chart-data="datacollection" height="150"></line-chart>
      </div> -->

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Modal from '@/components/Modal.vue'
  import ChartCard from '@/components/Cards/ChartCard.vue'
  import StatsCard from '@/components/Cards/StatsCard.vue'
  import LTable from '@/components/Table.vue'
  import LineChart from './LineChart.js'
  import LineTrendChart from './LineTrendChart.js'
  import Api from '@/helpers/api';
  import dashboard from '@/services/dashboard.service';
  import produksi from '@/services/produksi.service';
  import config from '@/configs/config';
  var moment = require('moment');
  import Autocomplete from 'vue2-autocomplete-js'
  require('vue2-autocomplete-js/dist/style/vue2-autocomplete.css')
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  function hexToRgba(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16)
    var g = parseInt(hex.slice(3, 5), 16)
    var b = parseInt(hex.slice(5, 7), 16)
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')'
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard,
      LineChart,
      LineTrendChart,
      Modal,
      Autocomplete,
      flatPicker,
    },
    data () {
      return {
        moment:moment,
        formFilter: {
          add: true,
          title: "Filter",
          show: false
        },
        count_task : [],
        orderTrendChartData: null,
        productionTrendChartData: null,
        orderTrendChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { usePointStyle: true, boxWidth: 8, fontSize: 12, fontColor: '#67728c', padding: 16 } },
          scales: {
            xAxes: [{ gridLines: { display: false }, ticks: { fontColor: '#8a94a6', fontSize: 11 } }],
            yAxes: [{ gridLines: { color: 'rgba(52,70,117,.06)', zeroLineColor: 'rgba(52,70,117,.12)', drawBorder: false }, ticks: { beginAtZero: true, fontColor: '#8a94a6', fontSize: 11, callback: function(v) { return v + ' Ton' } } }]
          },
          tooltips: {
            backgroundColor: '#344675', cornerRadius: 6, displayColors: true, xPadding: 10, yPadding: 8,
            callbacks: { label: function(item, data) { return ' ' + data.datasets[item.datasetIndex].label + ': ' + Number(item.yLabel).toLocaleString('id-ID', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' Ton' } }
          }
        },
        productionTrendChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { usePointStyle: true, boxWidth: 8, fontSize: 12, fontColor: '#67728c', padding: 16 } },
          elements: {
            line: { tension: 0.35 },
            point: { radius: 3, hoverRadius: 5, borderWidth: 2, backgroundColor: '#fff' }
          },
          scales: {
            xAxes: [{ gridLines: { display: false }, ticks: { fontColor: '#8a94a6', fontSize: 11 } }],
            yAxes: [{ gridLines: { color: 'rgba(52,70,117,.06)', zeroLineColor: 'rgba(52,70,117,.12)', drawBorder: false }, ticks: { beginAtZero: true, fontColor: '#8a94a6', fontSize: 11, callback: function(v) { return v + ' Ton' } } }]
          },
          tooltips: {
            backgroundColor: '#344675', cornerRadius: 6, displayColors: true, xPadding: 10, yPadding: 8,
            callbacks: { label: function(item, data) { return ' ' + data.datasets[item.datasetIndex].label + ': ' + Number(item.yLabel).toLocaleString('id-ID', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' Ton' } }
          }
        },
        apiUrl :config.apiUrl,
        role: '',
        table: {
          data: []
        },
        search: {
          job_no: '',
          po_no: '',
          client_name: '',
          prod_class: '',
          date: '',
        },
        tokenApi : '',
     }
    },
    computed: {
      currentYear () {
        return new Date().getFullYear()
      }
    },
    mounted(){
      this.countTask();
      this.getProductionTrend();
      this.role = localStorage.getItem('role');
      this.tokenApi = 'Bearer '+localStorage.getItem('token');
    },
    methods: {
      getProductionTrend(){
        let context = this;
        Api(context, produksi.getRkpProduksiMonth({year: context.currentYear})).onSuccess(function(response) {
            context.buildProductionTrendChart(response.data.data);
        }).onError(function(error) {
        })
        .call()
      },
      buildProductionTrendChart (data) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Des']
        var monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']
        var classes = [
          { key: 'sltInt', label: 'Slitting', color: '#4c86d1' },
          { key: 'tll', label: 'Tolling', color: '#5cb583' },
          { key: 'shr', label: 'Shearing', color: '#dba434' },
        ]
        this.productionTrendChartData = {
          labels: monthLabels,
          datasets: classes.map(function(c) {
            return {
              label: c.label,
              borderColor: c.color,
              backgroundColor: hexToRgba(c.color, 0.08),
              pointBackgroundColor: c.color,
              pointBorderColor: '#fff',
              borderWidth: 3,
              fill: true,
              data: months.map(function(m) { return Math.round((Number((data[c.key] || {})[m] || 0) / 1000) * 100) / 100 })
            }
          })
        }
      },
      countTask(){
        let context = this;               
        Api(context, dashboard.countTask({job_no: context.search.job_no, job_name: context.search.job_name, po_no: context.search.po_no, prod_class: context.search.prod_class, date: context.search.date})).onSuccess(function(response) {    
            context.count_task = response.data.data;
            context.table.data = response.data.data.report;
            context.buildOrderTrendChart();
        }).onError(function(error) {
            if (error.response.status == 404) {
                context.count_job_request = [];
            }
        })
        .call()
      },
      buildOrderTrendChart () {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']
        var classes = [
          { key: 'Slitting', color: '#4c86d1' },
          { key: 'Tolling', color: '#5cb583' },
          { key: 'Shearing', color: '#dba434' },
        ]
        var weights = {}
        classes.forEach(function(c) { weights[c.key] = new Array(12).fill(0) })

        this.table.data.forEach(function(row) {
          if (!row.created_at || !row.prod_class) return
          var m = new Date(row.created_at).getMonth()
          if (weights[row.prod_class]) weights[row.prod_class][m] += Number(row.weight || 0) / 1000
        })

        this.orderTrendChartData = {
          labels: months,
          datasets: classes.map(function(c) {
            return {
              label: c.key,
              backgroundColor: c.color,
              hoverBackgroundColor: c.color,
              borderWidth: 0,
              barPercentage: 0.7,
              categoryPercentage: 0.6,
              data: weights[c.key].map(function(v) { return Math.round(v * 100) / 100 })
            }
          })
        }
      },
      sumField (arr, key) {
        if (!arr || !arr.length) return 0
        return arr.reduce(function(total, row) { return total + Number(row[key] || 0) }, 0)
      },
      sumProduct (arr, keyA, keyB) {
        if (!arr || !arr.length) return 0
        return arr.reduce(function(total, row) { return total + (Number(row[keyA] || 0) * Number(row[keyB] || 0)) }, 0)
      },
      filter() {
        this.formFilter.add   = true;
        this.formFilter.show  = true;
        this.formFilter.title = "Filter";
        this.$refs.autocomplete.clearInput()
      },
      convertRp(bilangan) {
        if (bilangan) {
          var number_string = bilangan.toString(),
              sisa    = number_string.length % 3,
              rupiah  = number_string.substr(0, sisa),
              ribuan  = number_string.substr(sisa).match(/\d{3}/g);

          if(ribuan){
            var separator = sisa ? '.' : '';
            rupiah += separator + ribuan.join('.');
            return rupiah
          }else{
            return bilangan
          }
        }
      },

      // ================= Autocomplete ============
      // AMBIL DATA YANG DI PILIH AC FILTER
      getDataFilter(obj){
        this.search.client_name = obj.client_name;
      },
      // AMBIL DATA DARI API AC
      processJSON(json) {
        return json.data
      },
    }
  }
</script>
<style lang='scss' scoped>
  @import "@/assets/scss/light-bootstrap-dashboard.scss";

  /* STAT CARD ACCENTS */
  .stat-accent ::v-deep .card-stats {
    border-top: 3px solid transparent;
    transition: transform .12s ease-in-out;
  }
  .stat-accent:hover ::v-deep .card-stats {
    transform: translateY(-2px);
  }
  .stat-accent-blue   ::v-deep .card-stats { border-top-color: #4c86d1; }
  .stat-accent-green  ::v-deep .card-stats { border-top-color: #5cb583; }
  .stat-accent-amber  ::v-deep .card-stats { border-top-color: #dba434; }
  .stat-accent-rose   ::v-deep .card-stats { border-top-color: #d5766f; }
  .stat-accent-violet ::v-deep .card-stats { border-top-color: #8f7bc9; }
  .stat-accent-sky    ::v-deep .card-stats { border-top-color: #4fa3d1; }
  .stat-accent-slate  ::v-deep .card-stats { border-top-color: #67728c; }

  /* CHART BOX */
  .chart-box {
    background: #fff;
    border: 1px solid #eef0f6;
    border-radius: 10px;
    padding: 16px 18px 6px 18px;
    box-shadow: 0 2px 8px rgba(52,70,117,.05);
  }
  .chart-box-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #344675;
    letter-spacing: .2px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 2px solid #eef0f6;
  }
  .chart-box-title i { font-size: 14px; color: #a9a9c1; }

  /* SECTION TITLE */
  .section-title {
    display: flex; align-items: center; gap: 8px; font-size: 14.5px !important;
    color: #344675; letter-spacing: .2px; margin: 10px 0 10px 0 !important;
    padding-bottom: 8px; border-bottom: 2px solid #eef0f6;
  }
  .section-title i { font-size: 15px; color: #a9a9c1; }
  .section-dot { width: 9px; height: 9px; border-radius: 50%; display: inline-block; flex-shrink: 0; }
  .dot-slate { background-color: #67728c; }
  .dot-blue  { background-color: #4c86d1; }
  .dot-green { background-color: #5cb583; }

  /* TABLE POLISH */
  table[border='1'] {
    border-collapse: separate !important; border-spacing: 0; width: 100%;
    border: 1px solid #e7e9f0 !important; border-radius: 8px; overflow: hidden;
  }
  table[border='1'] th, table[border='1'] td {
    border: 1px solid #eef0f6 !important; padding: 8px 10px !important; vertical-align: middle;
  }
  table[border='1'] thead th {
    text-transform: uppercase; letter-spacing: .3px; font-weight: 600 !important;
    white-space: nowrap;
  }
  table[border='1'] tbody tr:hover { background-color: #f4f6fb; }
  .row-highlight td {
    background-color: #eef1f8 !important; border-top: 2px solid #344675 !important;
    border-bottom: 2px solid #344675 !important; font-weight: 700 !important;
  }
</style>